import { APISettings } from "../../config/ApiSettings";
import { BaseAPI } from "./baseApi";

const baseUrl = new APISettings().getApiURL();

class HearingNoticeCommentApi<HearingNoticeComment> extends BaseAPI {
  public getByHearingNoticeId: (hearingNoticeId: number) => Promise<HearingNoticeComment> = async (hearingNoticeId: number) => {
    return (await BaseAPI.axios.get(`${baseUrl}/hearingNoticeComment/${hearingNoticeId}/get`)).data.output;
  }

  public createHearingNoticeComment: (hearingNoticeComment: HearingNoticeComment) => Promise<HearingNoticeComment> = 
    async (hearingNoticeComment: HearingNoticeComment) => {
      return (await BaseAPI.axios.post(`${baseUrl}/hearingNoticeComment`, hearingNoticeComment)).data.output;
    }
}

export const hearingNoticeCommentApi = new HearingNoticeCommentApi();